"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MIN_OVERFLOW_HEIGHT = exports.DETAIL_ITEM_CAPTION = void 0;
const DETAIL_ITEM_CAPTION = exports.DETAIL_ITEM_CAPTION = 'detail-item-caption';
const MIN_OVERFLOW_HEIGHT = exports.MIN_OVERFLOW_HEIGHT = 42;
